module.exports = __webpack_public_path__ + "static/media/CourseLogo.80481798.png";